const severeRiskProcess = (processStats) => {
  return processStats?.departments?.reduce(
    (value, department) => value + department.risks?.severe,
    0,
  )
}

export default severeRiskProcess
